var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { UserService } from './user.service';
import { IntegratorService } from './integrator.service';
var ResolverSelectedCustomerService = /** @class */ (function () {
    function ResolverSelectedCustomerService(integratorService, userService) {
        this.integratorService = integratorService;
        this.userService = userService;
    }
    ResolverSelectedCustomerService.prototype.resolve = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selectedCustomer, storedSelectedCustomerStr, storedSelectedCustomer_1, _a, client, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        selectedCustomer = this.userService.selectedCustomer.getValue();
                        if (!(!selectedCustomer && this.userService.customerInfo)) return [3 /*break*/, 5];
                        storedSelectedCustomerStr = localStorage.getItem(this.userService.selectedCustomerItemName);
                        if (!storedSelectedCustomerStr) return [3 /*break*/, 5];
                        storedSelectedCustomer_1 = JSON.parse(storedSelectedCustomerStr);
                        _a = this.userService.customerInfo.type;
                        switch (_a) {
                            case 'integrator': return [3 /*break*/, 1];
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        if (!!this.userService.clients) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.integratorService.getIntegratorClients()];
                    case 2:
                        _c.sent();
                        _c.label = 3;
                    case 3:
                        client = this.userService.clients.find(function (c) { return c.cusId === storedSelectedCustomer_1.id; });
                        if (client) {
                            selectedCustomer = {
                                id: client.cusId,
                                nameShort: client.cusNameShort,
                                adminEmails: client.adminEmails
                            };
                        }
                        return [3 /*break*/, 5];
                    case 4: 
                    // this.userService.customerInfo.children.find((c) => c.id === storedSelectedCustomer.id);
                    // Not sure if this is needed for end user
                    return [3 /*break*/, 5];
                    case 5:
                        if (!(!selectedCustomer && this.userService.customerInfo)) return [3 /*break*/, 10];
                        _b = this.userService.customerInfo.type;
                        switch (_b) {
                            case 'integrator': return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 9];
                    case 6:
                        if (!!this.userService.clients) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.integratorService.getIntegratorClients()];
                    case 7:
                        _c.sent();
                        _c.label = 8;
                    case 8:
                        if (this.userService.clients[0] && this.userService.clients[0].cusId) {
                            selectedCustomer = {
                                id: this.userService.clients[0].cusId,
                                nameShort: this.userService.clients[0].cusNameShort,
                                adminEmails: this.userService.clients[0].adminEmails
                            };
                        }
                        return [3 /*break*/, 10];
                    case 9:
                        selectedCustomer = {
                            nameShort: this.userService.customerInfo.nameShort,
                            id: this.userService.customerInfo.id,
                            adminEmails: this.userService.customerInfo.adminEmails
                        };
                        _c.label = 10;
                    case 10:
                        console.log('selectedCustomer', selectedCustomer);
                        this.userService.selectedCustomer.next(selectedCustomer);
                        return [2 /*return*/, selectedCustomer];
                }
            });
        });
    };
    return ResolverSelectedCustomerService;
}());
export { ResolverSelectedCustomerService };
